import * as React from "react";

import { Button, Tooltip, Card, Typography } from "@material-ui/core";
import { createStyles, withStyles, WithStyles } from "@material-ui/core/styles";

const styles = createStyles({
  container: {
    flex: "1 1 250px"
  },
  button: {
    width: "100%"
  },
  cardContent: {
    padding: "1rem",
    color: "#fff",
    width: "100%"
  },
  bgDefault: {
    backgroundColor: "#192e5b"
  },
  root: {
    borderRadius: ".7rem",
    position: "relative",
    flex: "1 1 250px"
  },
  cardContainer: {
    display: "flex",
    height: "175px",
    position: "relative",
    flexBasis: "200px"
  },
  icon: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    width: "100%",

    position: "absolute",
    top: "35px",
    right: "20px",

    "& svg": {
      fill: "#d7d8d80d",
      height: "150px",
      width: "150px"
    }
  }
});

interface IPharmacyRole {
  pharmacy_role_id: number;
  PharmacyRoleName: string;
  PharmacyQualified: number;
}

interface IUniversityRole {
  auth_id: number;
  role_id: number;
  link_id: number;
  company_id: number;
  Active: number;
  IsNewUser: number;
  lastLogin: string;
  university_role_id: number;
  UniversityRoleName: string;
  from_db: number;
}

interface IChatRole {
  role: string;
}

interface IRole extends IPharmacyRole, IUniversityRole, IChatRole { }

interface IProps extends WithStyles<typeof styles> {
  label: string;
  tooltip?: string;
  disable?: boolean;
  bgColor?: string;
  fontColor?: string;
  icon: any;
  onClick?(): void;
}

class AppCardButtonUnstyled extends React.Component<IProps> {
  public handleClick = () => {
    const { onClick, disable } = this.props;

    if (!disable && onClick) {
      onClick();
    }
  };

  public render() {
    const {
      tooltip = "",
      disable = false,
      label = "",
      bgColor,
      icon
    } = this.props;

    return (
      <Tooltip title={tooltip} placement="bottom">
        <div className={this.props.classes.container}>
          <Card className={`${bgColor} ${this.props.classes.root}`}>
            <Button
              className={this.props.classes.button}
              disabled={disable}
              onClick={this.handleClick}
            >
              <div className={this.props.classes.cardContainer}>
                <div className={this.props.classes.cardContent}>
                  <Typography color="inherit" variant="h5" gutterBottom={true}>
                    {label}
                  </Typography>
                </div>
                {icon ? (
                  <div className={this.props.classes.icon}>{icon}</div>
                ) : null}
              </div>
            </Button>
          </Card>
        </div>
      </Tooltip>
    );
  }
}

export const AppCardButton = withStyles(styles, { withTheme: true })(
  AppCardButtonUnstyled
);



// WEBPACK FOOTER //
// ./src/modules/apps/AppCardButton.tsx